import React from "react";

const DefaultFooter = () => (
  <React.Fragment>
    <span>
      &copy; {new Date().getFullYear()}
      <a
        href="https://comsystoreply.de/"
        className="ml-1"
        target="_blank"
        rel="noopener noreferrer"
      >
        Comsysto Reply d.o.o.
      </a>
    </span>
  </React.Fragment>
);

export default DefaultFooter;
